exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.align-center[data-v-af70aeda] {\n    align-items: center;\n}\n", ""]);

// exports
